export const PRICE_RANGE_OPTIONS = {
  'undefined|201': 'under $200',
  '199|401': '$200 - $400',
  '399|801': '$400 - $800',
  '799|undefined': 'over $800',
};

export const PAGE_SIZE = 3;
